<template>
  <section class="section" id="format">
    <div class="wrap">
      <div class="section-head">
        <div>
          <div class="eyebrow-line">El formato</div>
          <h2>RUN · LIFT · CARRY.<br />EN PAREJAS.</h2>
        </div>
        <p class="intro-text">
          La Menorca Hybrid Race combina carrera y pruebas funcionales en el corazón histórico de Ciutadella.
          Dos atletas. Diez estaciones. Una clasificación por mejor tiempo de pareja.
        </p>
      </div>
      <div class="pillars">
        <div class="pillar">
          <span class="num">01</span>
          <Users class="icon" />
          <h3>Parejas</h3>
          <p>Compite junto a tu compañero o compañera. Las parejas mixtas levantan peso masculino.</p>
        </div>
        <div class="pillar">
          <span class="num">02</span>
          <Dumbbell class="icon" />
          <h3>10 pruebas</h3>
          <p>Burpees, sky, sit-ups, row, assault bike, thrusters, push-ups, kettlebell swing, lunges, wallball.</p>
        </div>
        <div class="pillar">
          <span class="num">03</span>
          <Footprints class="icon" />
          <h3>Run entre todas</h3>
          <p>750 metros de carrera entre cada prueba en Pro · 500 m en Open. La Plaça des Born es el circuito.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { Users, Dumbbell, Footprints } from 'lucide-vue-next'
</script>

<style scoped>
.intro-text {
  max-width: 460px;
  color: var(--fg-2);
  font-size: 18px;
  margin: 0;
  line-height: 1.55;
}
</style>
